export default [
  {
    path: '/attendances',
    name: 'Attendance_List',
    component: () => import('@/views/hr/attendance.vue'),
    meta: {
      authRequired: true,
      permission: 'attendances.index'
    }
  },{
    path: '/update-vacation',
    name: 'Update_Vacation',
    component: () => import('@/views/hr/update-vacation.vue'),
    meta: {
      authRequired: true,
      permission: 'remainVacation'
    }
  },
]
